import { ReactNode } from "react";
import { ISwapPathInfo } from "../../../api/swap";

export type AddressBookOrder = {
  to_address: string;
  amount: string;
  display_name: string;
  wallet_type: string;
  to_wallet_tag: string;
  rawItem?: any;
};

export type AmountSnapshot = {
  exactAmount: string | null;
  maxSlippage: string | null;
};

export interface FilterFields {
  chainName: string;
  currencyPair: string;
  fromCurrency: string;
  toCurrency: string;
  maxSlippage: string;
  isTronRent: boolean;
}

// Base interface for shared fields
export interface BaseSwapFields {
  walletAddress: string;
  balance: string;
  amountSnapShot: AmountSnapshot;
  addressBookOrder: AddressBookOrder;
  estimateAmount: string;
  exchangeRate: string;
  quotedTime: string;
  rawWalletInfo: any;
}

export interface ExactPayFields extends BaseSwapFields {
  exactPayAmount: string;
  getMin: string;
}

export interface ExactGetFields extends BaseSwapFields {
  exactGetAmount: string;
  payMax: string;
}

export enum TabTypes {
  EXACT_PAY = "exactPay",
  EXACT_GET = "exactGet",
}

export enum ExactPaySlippageTypes {
  MAX_SLIPPAGE_0 = "exact_pay_max_slippage_0",
  MAX_SLIPPAGE_0_1 = "exact_pay_max_slippage_0_1",
  MAX_SLIPPAGE_0_25 = "exact_pay_max_slippage_0_25",
  MAX_SLIPPAGE_0_5 = "exact_pay_max_slippage_0_5",
  MAX_SLIPPAGE_0_75 = "exact_pay_max_slippage_0_75",
  MAX_SLIPPAGE_1 = "exact_pay_max_slippage_1",
}

export interface CreateSwapRequestContextType {
  // filter state
  filterFields: FilterFields;
  setFilterFields: (fields: FilterFields) => void;

  // tabs state
  activeTabId: TabTypes;
  setActiveTabId: (tabId: TabTypes) => void;
  maxSlippageTabId: ExactPaySlippageTypes;
  setMaxSlippageTabId: (tabId: ExactPaySlippageTypes) => void;
  // data state
  exactPayFields: ExactPayFields;
  setExactPayFields: (fields: ExactPayFields) => void;
  exactGetFields: ExactGetFields;
  setExactGetFields: (fields: ExactGetFields) => void;
  swapPaths: ISwapPathInfo[];
  setSwapPaths: (paths: ISwapPathInfo[]) => void;

  // helper functions
  resetEverything: (isResetActiveTab?: boolean) => void;
  resetContent: () => void;
  resetQuoteDetails: () => void;
}

export interface CreateSwapRequestProviderProps {
  children: ReactNode;
}
